var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#bfebff;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile_edit"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.45,432.64l-71.88-71.71,236-235.43a17.49,17.49,0,0,1,24.69,0l47.21,47.1a17.39,17.39,0,0,1,0,24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.44,432.64l-70.76,18.92a27.87,27.87,0,0,0-20-19.92l19-70.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.01 359.65 160.57 361.16 184.5 385.09 186.01 359.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "209.93 383.55 184.49 385.06 208.42 409 209.93 383.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233.71 407.2 208.27 408.71 232.2 432.64 233.71 407.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.68,451.56l-27.28,7.29,7.31-27.21A27.87,27.87,0,0,1,161.68,451.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a473f5baa7ab4a3e26392ae6d862f7fc.svg";
export { ForwardRef as ReactComponent };